export const setAllCampaigns = (state, payload) => state.allCampaigns = payload;
